import { setCookie, parseCookies } from 'nookies';
import { Locales } from '../enum/locales';
import { ITranslation } from '../interfaces/i-translation';
import { TLocales } from '../type/locales';
import { OptimizedImage } from './optimized-image';
import { DEFAULT_TRANSLATION } from '../const/default-translation';
import { coockieAge, translationCoockieName } from '../const/coockie';

export class Translation {
  id: number;
  guid: string;
  slug: string;
  titleEn: string;
  titleAr: string;
  name: string;
  language: string;
  translatorName: string;
  image: OptimizedImage | null;

  constructor(data: ITranslation, locale: TLocales | string = Locales.en) {
    this.id = data.id;
    this.guid = data.guid;
    this.slug = data.slug;
    this.titleEn = data.title_en;
    this.titleAr = data.title_ar;
    this.name = data.name;
    this.language = data.language;
    this.translatorName = data.translator_name;
    this.image = data.image ? new OptimizedImage(data.image) : null;
  }

  static saveServerSideTranslationCoockie(
    ctx: any,
    translations: ITranslation[],
    translationSlug: string
  ): string {
    let translation = translationSlug;

    const hasTranslation = translations.some((el) => el.slug === translation);

    if (hasTranslation) {
      setCookie(ctx, translationCoockieName, translation, {
        maxAge: coockieAge,
        path: `/`,
      });
    } else {
      const cookies = parseCookies(ctx, {
        path: `/`,
      });
      translation = cookies[translationCoockieName] || DEFAULT_TRANSLATION;
    }

    const isDefaultTranslation = translation === DEFAULT_TRANSLATION;

    if (isDefaultTranslation) translation = '';

    return translation;
  }
}
